module.exports = __webpack_public_path__ + "static/media/game-icon-retry.ec9875eb.png";